import { User } from '../types/auth';
import { UserAffinity } from '../types/menuConfig';

/**
 * Deriva a afinidade a partir dos vínculos de tenant (nunca de nome de papel).
 *
 * - 1 prestador (+ N empresas) → 'clinic'
 * - 1 empresa   (+ N prestadores) → 'company'
 * - 0/0 ou N/N  → 'global'
 */
export function resolveAffinity(user: User | null): UserAffinity {
  const ctx = user?.tenantContext;
  if (!ctx) return 'global';
  const providers = ctx.providerIds.length;
  const companies = ctx.companyIds.length;
  if (providers === 1 && companies !== 1) return 'clinic';
  if (companies === 1 && providers !== 1) return 'company';
  return 'global';
}
